/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Eye3(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Eye3.glb')
  return (
    <group {...props} dispose={null}>
      <group position={[-1.78, 264.85, 113.29]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Eye3-White'].geometry}
          material={materials.White}
        />
        <mesh castShadow receiveShadow geometry={nodes['Eye3-Black'].geometry}>
          <meshPhysicalMaterial color={colorArr[1]} reflectivity={1} />
        </mesh>
      </group>
    </group>
  )
}

useGLTF.preload('/models/Eye3.glb')
